import React, { useEffect, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import UnicommerceStepInfo from './StepInfo';
import UnicommerceAccountForm from './Steps/UnicommerceAccountForm';
import UnicommerceMapLocations from './Steps/UnicommerceMapLocations';
import UnicommerceAccountSync from './Steps/UnicommerceAccountSync';
import UnicommerceConfigurations from './Steps/UnicommerceConfigurations';
import UnicommerceSuccess from './Steps/UnicommerceSuccess';
import UcPng from '@Images/admin/integrations/unicommerce.png';
import { Image } from 'antd';
import './style.scss';
import '../../../../../scss/integration.scss'
/**
 *
 */
const UnicommerceSetup = ({
  user, unicommerceConnections, getUnicommerceConnections, getUnicommerceConnectionsLoading, getTenantsLoading,
}) => {
  const [step, setStep] = useState(1);

  useEffect(() => {
    getUnicommerceConnections(user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    if (unicommerceConnections?.success) {
      if (unicommerceConnections?.data?.product_sync_status === 'IN_PROGRESS') {
        setStep(3);
      } else if (unicommerceConnections?.data?.product_sync_status === 'SUCCESS' && unicommerceConnections?.data?.product_sync_completion) {
        setStep(3);
      } else if (unicommerceConnections?.data?.product_sync_status === 'SUCCESS') {
        setStep(4);
      } else {
        setStep(2);
      }
    }
  }, [unicommerceConnections]);

  return (
    <Fragment>
      <div className="integration-home__wrapper">
        <div className="unicommerce-integration__heading"></div>
        <div className="integration-home__header">
          <div className="flex-display flex-align-c">
            <Image src={UcPng} className="integration-home__heading" preview={false} />
            &nbsp;
            Unicommerce
          </div>
        </div>
        <div className="ant-row">
          <div className="ant-col-md-5">
            <UnicommerceStepInfo step={step} setStep={setStep} loading={getUnicommerceConnectionsLoading || getTenantsLoading} />
          </div>
          <div className="ant-col-md-19">
            {getUnicommerceConnectionsLoading ? (
              <div className="unicommerce-integration__loader__wrapper">
                <div className="loadingBlock unicommerce-integration__loader__line1" />
                <div className="loadingBlock unicommerce-integration__loader__line2" />
                <div className="loadingBlock unicommerce-integration__loader__line3" />
              </div>
            ) : (
              <React.Fragment>
                {step === 1 && (<UnicommerceAccountForm setStep={setStep} />)}
                {step === 2 && (<UnicommerceMapLocations setStep={setStep} />)}
                {step === 3 && (<UnicommerceAccountSync setStep={setStep} />)}
                {step === 4 && (<UnicommerceConfigurations setStep={setStep} unicommerceConnections={unicommerceConnections} />)}
                {step === 5 && (<UnicommerceSuccess />)}
              </React.Fragment>
            ) }
          </div>

        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, UnicommerceIntegrationReducers, TenantReducers }) => ({
  user: UserReducers.user,
  unicommerceConnections: UnicommerceIntegrationReducers.unicommerceConnections,
  getUnicommerceConnectionsLoading: UnicommerceIntegrationReducers.getUnicommerceConnectionsLoading,
  getTenantsLoading: TenantReducers.getTenantsLoading,

});

const mapDispatchToProps = (dispatch) => ({
  getUnicommerceConnections: (orgId, callback) => dispatch(UnicommerceIntegrationActions.getUnicommerceConnections(orgId, callback)),

});

UnicommerceSetup.propTypes = {
  unicommerceConnections: PropTypes.any,
  getUnicommerceConnections: PropTypes.func,
  user: PropTypes.any,
  getUnicommerceConnectionsLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnicommerceSetup));
